// extracted by mini-css-extract-plugin
export var assigneeBadge = "_k0-0";
export var assigneeDetails = "_k0-1";
export var assigneeInfo = "_k0-2";
export var dropdownContainer = "_k0-4";
export var dropdownImage = "_k0-5";
export var editAssigneeInfo = "_k0-3";
export var editAssigneeModalContainer = "_k0-6";
export var hidden = "_k0-8";
export var input = "_k0-7";